import { z } from 'zod';

/**
 * Minimal schema covering the fields we read from /api/crm/coworkertasks.
 * `passthrough()` keeps any extra Nexudus fields on the parsed object so we
 * don't accidentally drop data, while still failing on missing required keys.
 */
export const NexudusCoworkerTaskSchema = z
  .object({
    Id: z.number(),
    Name: z.string(),
    CoworkerId: z.number(),
    Completed: z.boolean(),
  })
  .passthrough();

export const NexudusCoworkerTaskListResponseSchema = z.object({
  Records: z.array(NexudusCoworkerTaskSchema),
});

export type INexudusCoworkerTask = z.infer<typeof NexudusCoworkerTaskSchema>;
